import { IRateTypeKeyTypes } from 'types/graphqlTypes'

const rateTypeLabel: Record<string, string> = {
  rfp_lane_carrier_line_haul_rpm: 'RPM',
  rfp_lane_carrier_line_haul_flat: 'Linehaul',
  rfp_lane_carrier_all_in: 'All In',
}

export const getRateTypeLabel = (rateType: IRateTypeKeyTypes): string =>
  rateTypeLabel[rateType] ?? rateType
